<template>
  <div class="topup-result">
    <div v-if="topupResult === 'success'">
      <img src="@/assets/image/dashboard/topup/success.png" alt="success" class="result-icon">
      <div class="text">
        <div class="title">{{ $t('congratulation') }}</div>
        <div class="desc">{{ $t('topupSuccess') }}</div>
      </div>
      <div class="buttons">
        <md-button type="primary" class="button" @click="switchRoute('Product', 1)">
          {{ $t('startInvest') }}
        </md-button>
        <md-button type="primary" plain class="button" @click="switchRoute('UserOverview', 3)">
          {{ $t('viewAccount') }}
        </md-button>
      </div>
    </div>
    <div v-else-if="topupResult === 'fail'">
      <img src="@/assets/image/dashboard/topup/fail.png" alt="fail" class="result-icon">
      <div class="text">
        <div class="title">{{ $t('sorry') }}</div>
        <div class="desc">{{ $t('topupFailed') }}</div>
      </div>
      <div class="buttons">
        <md-button type="primary" class="button" @click="switchRoute('UserTopup')">
          {{ $t('tryAgain') }}
        </md-button>
        <md-button type="primary" plain class="button" @click="switchRoute('UserOverview', 3)">
          {{ $t('viewAccount') }}
        </md-button>
      </div>
    </div>
    <div v-else>
      <img src="@/assets/image/dashboard/topup/process.png" alt="process" class="result-icon">
      <div class="text">
        <div class="title">{{ $t('process') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        congratulation: 'Congratulation!',
        topupSuccess: 'You have topped up successfully, you can start your investment now.',
        startInvest: 'Start to Invest',
        sorry: 'Sorry!',
        topupFailed: 'We are unable to complete your top up transaction. Please try again later.',
        tryAgain: 'Try Again',
        process: 'Processing…',
        viewAccount: 'View Your Account',
      },
      id: {
        congratulation: 'Selamat!',
        topupSuccess: 'Penyaluran dana nominal Anda berhasil, Anda bisa memulai pendanaan sekarang.',
        startInvest: 'Mulai Pendanaan',
        sorry: 'Maaf!',
        topupFailed: 'Kami tidak dapat menyelesaikan transaksi penyaluran dana nominal Anda. Silakan coba lagi nanti.',
        tryAgain: 'Coba lagi',
        process: 'Processing…',
        viewAccount: 'Lihat Akun Anda',
      },
    },
  },
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      callbackResult: 'PROCESSING',
      pollingInterval: null,
    }
  },
  computed: {
    topupResult() {
      return this.$route.query.type || 'process'
    },
  },
  async mounted() {
    if (this.topupResult === 'process') {
      await this.getInvoice()
      if (this.callbackResult === 'PROCESSING') {
        this.pollingInterval = setInterval(this.getInvoice, 10000)
      }
    }
  },
  methods: {
    async getInvoice() {
      try {
        const params = {
          c: '1',
          id: this.$store.state.userInfo.id,
          requestId: this.$route.query.orderId,
        }
        const response = await this.$http.get('/invested-payment-api/payment/invoice', { params })
        if (response.data.data[0].status === 'DONE') {
          clearInterval(this.pollingInterval)
          this.pollingInterval = null
          if (window.bridge && window.bridge.afTrackEvent) {
            window.bridge.afTrackEvent('top-up succeed', '')
          }
          this.$router.push({ name: 'UserTopupResult', query: { type: 'success' } })
        }
        if (['DENIED', 'CANCLED'].includes(response.data.data[0].status)) {
          clearInterval(this.pollingInterval)
          this.pollingInterval = null
          this.$router.push({ name: 'UserTopupResult', query: { type: 'fail' } })
        }
        this.callbackResult = response.data.data[0].status
      } catch (error) {
        console.error(error)
      }
    },
    switchRoute(name, appTab) {
      if (window.bridge && window.bridge.changeMainTab && appTab) {
        window.bridge.changeMainTab(appTab)
        return
      }
      this.$router.push({ name: name })
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.pollingInterval)
    this.pollingInterval = null
    next()
  },
}
</script>

<style lang="stylus" scoped>
.topup-result {
  padding: 80px 40px 0;
  text-align: center;
  background #fff;
  height calc(100vh - 124px);
}

.result-icon {
  width: 66px;
  height: 66px;
}

.text {
  padding: 20px 0 40px 0;
}

.title {
  font-size: 20px;
  padding-bottom: 10px;
}

.desc {
  color: #555555;
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  .button {
    margin: 0 0 15px 0;
    width: 80%;
  }
}
</style>
